import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';
import { I18nService } from '../../services/general-utils';
import { LANGUAGES } from '../../../shared/constants/app.constants';
import { CodeDescription } from '../../models/general/code-description';
import { AccountService } from '../../services/rest/account.service';
import { UserService } from '../../services/rest/user.service';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit {

  @ViewChild('navbarCollapsibleBtnRef') navbarCollapsibleBtnRef: ElementRef;
  @ViewChild('navbarCollapsibleContentRef') navbarCollapsibleContentRef: ElementRef;
  languages: CodeDescription[] = [];

  constructor(
    public deviceService: DeviceDetectorService,
    public i18nService: I18nService,
    private sessionStorage: SessionStorageService,
    private accountService: AccountService,
    public userService: UserService,
    public router: Router
  ) {
  }

  ngOnInit() {
    for (const lang of this.i18nService.supportedLanguages) {
      const language = LANGUAGES.find(l => l[lang]);
      this.languages.push({
        code: lang,
        description: language[lang]
      });
    }
  }

  ngAfterViewInit() {
    // if (this.deviceService.isMobile() && document.getElementById('sidebarCollapse-navbar')) {
    //   document.getElementById('sidebarCollapse-navbar').classList.toggle('active');
    //   document.getElementById('sidebarCollapse-navbar').classList.toggle('open');
    // }
  }

  changeLanguage(langKey: string): void {
    this.sessionStorage.store('locale', langKey);
    this.i18nService.language = langKey;
  }

  isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

  logout(): void {
    this.accountService.logout();
  }

  forceSidebarMinimize() {
    document.getElementById('sidebar').classList.add('minimized');
  }

  isMinimized(): boolean {
    return document.getElementById('sidebar').classList.contains('minimized');
  }

  toggleSidebar() {
    if (this.deviceService.isDesktop()) {
      document.getElementById('main_sidebar').classList.toggle('isMinimized'); // per gestione z-index!
      document.getElementById('sidebar').classList.toggle('minimized');
      document.getElementById('sidebarCollapse').classList.toggle('active');
      document.getElementById('sidebarCollapse').classList.toggle('open');
    } else {
      // gestione "mobile"
      document.getElementById('sidebar').classList.remove('active');
      document.getElementById('blockScreen').classList.remove('active');
    }
  }

}
